import { useState, useEffect } from "react";

const sections = [
  { id: "accueil", label: "Accueil" },
  { id: "horloge", label: "Horloge" },
  { id: "jeu", label: "Jeu" },
  { id: "score", label: "Score" },
  { id: "parametres", label: "Paramètres" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("accueil");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      // Determine active section
      const sectionElements = sections.map((s) => ({
        id: s.id,
        element: document.getElementById(s.id),
      }));

      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const el = sectionElements[i].element;
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 150) {
            setActiveSection(sectionElements[i].id);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <button
            onClick={() => scrollTo("accueil")}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className="w-9 h-9 rounded-full border-2 border-brand-text flex items-center justify-center">
              <i className="ri-time-line text-brand-text text-lg" />
            </div>
            <span
              className={`font-display text-xl font-semibold tracking-tight transition-colors ${
                scrolled ? "text-brand-text" : "text-brand-text"
              }`}
            >
              Apprendre
            </span>
          </button>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => scrollTo(section.id)}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeSection === section.id
                    ? "text-brand-accent"
                    : scrolled
                    ? "text-brand-text/70 hover:text-brand-text"
                    : "text-brand-text/70 hover:text-brand-text"
                }`}
              >
                {section.label}
              </button>
            ))}
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i
              className={`ri-${
                mobileOpen ? "close-line" : "menu-line"
              } text-2xl text-brand-text`}
            />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-6 py-4 flex flex-col gap-3">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => scrollTo(section.id)}
                className={`text-left text-sm font-medium py-2 transition-colors cursor-pointer ${
                  activeSection === section.id
                    ? "text-brand-accent"
                    : "text-brand-text/70"
                }`}
              >
                {section.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}